import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
// 懒加载组件 - 保持原有的导入路径和组件名
var RVFViewer = lazy(function () { return import('./components/RVFViewer'); });
var HomeViewer = lazy(function () { return import('./components/HomeViewer'); });
var Demo = lazy(function () { return import('./views/Demo/Demo'); });
var Navigation = function () {
    var location = useLocation();
    return (_jsxs("nav", { style: {
            display: 'flex',
            gap: '20px',
            marginBottom: '30px',
            padding: '20px',
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }, children: [_jsx(Link, { to: "/", style: {
                    padding: '10px 20px',
                    borderRadius: '6px',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    backgroundColor: location.pathname === '/' ? '#4CAF50' : '#f5f5f5',
                    color: location.pathname === '/' ? 'white' : '#333',
                    transition: 'all 0.3s ease',
                }, children: "RVF \u67E5\u770B\u5668" }), _jsx(Link, { to: "/home-viewer", style: {
                    padding: '10px 20px',
                    borderRadius: '6px',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    backgroundColor: location.pathname === '/home-viewer' ? '#4CAF50' : '#f5f5f5',
                    color: location.pathname === '/home-viewer' ? 'white' : '#333',
                    transition: 'all 0.3s ease',
                }, children: "\u5BB6\u5EAD\u67E5\u770B\u5668" }), _jsx(Link, { to: "/demo", style: {
                    padding: '10px 20px',
                    borderRadius: '6px',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    backgroundColor: location.pathname === '/demo' ? '#4CAF50' : '#f5f5f5',
                    color: location.pathname === '/demo' ? 'white' : '#333',
                    transition: 'all 0.3s ease',
                }, children: "\u5BB6\u5EAD\u7248\u6F14\u793A" })] }));
};
// 加载中组件
var LoadingFallback = function () { return (_jsx("div", { style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '200px',
        fontSize: '16px',
        color: '#666'
    }, children: "\u52A0\u8F7D\u4E2D..." })); };
var App = function () {
    return (_jsx(Router, { children: _jsxs("div", { className: "app", children: [_jsx(Navigation, {}), _jsx(Suspense, { fallback: _jsx(LoadingFallback, {}), children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(RVFViewer, {}) }), _jsx(Route, { path: "/home-viewer", element: _jsx(HomeViewer, {}) }), _jsx(Route, { path: "/demo", element: _jsx(Demo, {}) })] }) })] }) }));
};
export default App;
